import { useClassStore } from '@Utils/useClassStore';
import { injectable } from 'inversify';
import { action, observable } from 'mobx';

import UserAPI from '~gateways/user-api';
import container from '~ioc/ioc';

@injectable()
class SupportStore {
  @observable uiSupportPanelOpen: boolean = false;

  @action sendSupportMessage = async (subject: string, message: string) =>
    UserAPI.sendSupportMessage(subject, message);
}

export const useSupportStore = () =>
  useClassStore<SupportStore>(container.get(SupportStore));

export default SupportStore;
